import Vue from 'vue'
import Vuex from 'vuex'
import { stat } from 'fs';

Vue.use(Vuex)


export default new Vuex.Store({
    state: {
        pageSetup: null,
    },
    getters: {
        loadPageSetUp: state => state.pageSetup,
    },
    actions: {
        // server actions
        // getSectionsData({commit}) {
        //     axios.get(window.url + window.GlobalLang + window.JsonUrl + 'section').then(async (response) => {
        //         console.log(response.data, 'pages');
        //         commit('PageSetUp', response.data[0].acf);
        //     });
        // },
    },
    mutations: {
        // server mutations
        PageSetUp(state, setup) {
            state.pageSetup = setup
        },
    }
})
